module.exports = __webpack_public_path__ + "2d225f2de6860ebdd40af7c890b40300.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/360-3.png
// module id = 909
// module chunks = 3